module.exports = __webpack_public_path__ + "img/dowen.a561a19.png";